import { STATUS_LABELS } from '@shared/ui-components/au-cmms-status-label/statuses';
import { IStatusLabels } from '@shared/ui-components/au-cmms-status-label/interfaces/status-labels.interface';

export class StatusLabel {
	public static readonly statuses: IStatusLabels = STATUS_LABELS;

	public static getColorByKey(key: string): string {
		if (!key) {
			return undefined;
		}
		// TODO Talk with backhand about strict name for avoiding toLocaleUpperCase
		return this.statuses[this.statusByKey(key.toLocaleUpperCase())].color;
	}

	public static getNameByKey(key: string): string {
		if (!key) {
			return undefined;
		}
		// TODO Talk with backhand about strict name for avoiding toLocaleUpperCase
		return this.statuses[this.statusByKey(key.toLocaleUpperCase())].name;
	}

	private static statusByKey(key: string): string {
		// TODO Talk with backhand about strict name for avoiding toLocaleUpperCase
		if (!this.statuses[key.toLocaleUpperCase()]) {
			throw new Error(`'${key}' is not defined in StatusLabel`);
		}
		return key;
	}
}
